import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      className="theme-toggle"
      onClick={toggleTheme}
      aria-label="Cambia tema"
      title={theme === 'dark' ? 'Passa al tema chiaro' : 'Passa al tema scuro'}
    >
      <span className="theme-toggle__icon">{theme === 'dark' ? '☀️' : '🌙'}</span>
    </button>
  );
};

export default ThemeToggle;
